module.exports = __webpack_public_path__ + "3f48a43705c09f0fc2c35988109897f7.jpg";